import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromExhibition from './exhibition.reducer';

export const selectExhibitionState = createFeatureSelector<fromExhibition.State>(
  fromExhibition.exhibitionsFeatureKey
);

export const getExhibitions = createSelector(selectExhibitionState, fromExhibition.selectAll);
export const getExhibitionsDict = createSelector(selectExhibitionState, fromExhibition.selectEntities);
export const getSelectedId = createSelector(selectExhibitionState, state => state.selected);

export const getSelected = createSelector(
  getExhibitionsDict,
  getSelectedId,
  (exhibitions, id) => exhibitions[ id ]
);
